import ComponentManager from '@/Management/ComponentManager';
import ExpanderBoxViewModel from '@/ViewModels/Controls/ExpanderBoxViewModel';
import ContainerViewModel from '@/ViewModels/Controls/ContainerViewModel';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';

export default class ExpanderGroupBoxViewModel extends ContainerViewModel {

    private ExpanderBoxViewModel = ComponentManager.getViewModel<typeof ExpanderBoxViewModel>('ExpanderBoxViewModel');

    /**
     * Gibt an, ob die Box zugeklappt ist
     */
    public isCollapsed: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die Box oder ein Vorfahre zugeklappt ist
     */
    public isCollapsedWithAncestors: KnockoutObservable<boolean>;

    /**
     * Definiert den Namen des inneren Layouts
     */
    public layout: string;

    /**
     * Das ViewModel für die ExpanderBox
     */ 
    public expanderVM: ExpanderBoxViewModel;

    /**
     * Gibt das Level (in der Hierarchie) der ExpanderGroupBox an
     */
    public level: number;

    /**
     * Das ViewModel für die ExpanderGroupBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.context = this.paramOrDefault(params.context, null);
        this.isCollapsed = this.observableOrDefault(params.isCollapsed, false);
        this.isCollapsedWithAncestors = this.observableOrDefault(params.isCollapsedWithAncestors, false);
        this.layout = this.paramOrDefault(params.layout, 'NoneLayout');
        this.detailViewGroups = this.paramOrDefault(params.detailViewGroups, []);
        this.detailViewItems = this.paramOrDefault(params.detailViewItems, []);
        this.link = this.paramOrDefault(params.link);
        this.level = this.paramOrDefault(params.level, 1);
        this.expanderVM = this.paramOrDefault(params.expanderVM, new this.ExpanderBoxViewModel({
            isCollapsed: this.isCollapsed,
            layout: this.layout,
            link: this.link,
            level: this.level
        }));

        if (this.context && this.context instanceof DetailViewContext && this.context.isSummaryViewMode && this.context.isSummaryViewMode())
            this.layout = 'OneColumnLayout';
    }
}

ComponentManager.setViewModel('ExpanderGroupBoxViewModel', ExpanderGroupBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');